export const NIPPON_BOT_COMPANY_ID = "6a635ef66fb85dcdebe3d9b6";
// Every client using the isolated interview-bot flow (upload -> 4-phase
// interview evaluation -> compiled candidate report). Add new clients here.
export const INTERVIEW_BOT_COMPANY_IDS = [NIPPON_BOT_COMPANY_ID];

